<template>
  <div class="flex-container">
    <div class="flex-header">
      <div class="header-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/sys/workflow/workflowList' }">流程列表</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/sys/workflow/view/' + flowId }">{{ workflowName }}</el-breadcrumb-item>
          <el-breadcrumb-item>门店列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="header-stats">
          <div class="stats-item">
            <span class="stats-num">{{ totalStoreNum }}</span>
            <span class="stats-label">门店总数</span>
          </div>
        </div>
      </div>
      <el-form :inline="true" size="mini" :model="searchForm" class="search-form">
        <el-form-item label="所属商户：">
          <el-select v-model="searchForm.merchantId" clearable placeholder="请选择商户" style="width:180px;">
            <el-option v-for="item in merchants" :key="item.merchantId" :label="item.merchantName" :value="item.merchantId" />
          </el-select>
        </el-form-item>
        <el-form-item label="门店名称：">
          <el-input v-model="searchForm.storeName" clearable placeholder="请输入门店名称" style="width:170px;" />
        </el-form-item>
        <el-form-item label="门店编码：">
          <el-input v-model="searchForm.storeCode" clearable placeholder="请输入门店编码" style="width:150px;" />
        </el-form-item>
        <el-form-item label="地址：">
          <el-input v-model="searchForm.address" clearable placeholder="请输入地址" style="width:180px;" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="action-bar">
        <el-button size="small" type="primary" @click="addStore"><i class="el-icon-plus"></i> 新增门店</el-button>
        <el-button size="small" @click="importStoreExcel"><i class="el-icon-upload2"></i> 导入门店Excel</el-button>
        <el-button size="small" @click="exportStore"><i class="el-icon-download"></i> 导出</el-button>
      </div>
    </div>
    <div class="flex-item table-wrapper">
      <el-table :data="tableData" border size="small" style="width:100%;" v-loading="tableLoading" :height="tableHeight">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="storeCode" label="门店编码" width="120" align="center" />
        <el-table-column prop="storeName" label="门店名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="merchantName" label="所属商户" width="140" show-overflow-tooltip />
        <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip />
        <el-table-column prop="contact" label="联系人" width="80" align="center" />
        <el-table-column prop="phone" label="电话" width="120" align="center" />
        <el-table-column prop="area" label="面积(m2)" width="80" align="center" />
        <el-table-column label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'" size="small">
              {{ scope.row.status === '1' ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStoreAuditStatus(scope.row.storeId).color" size="small">
              {{ getStoreAuditStatus(scope.row.storeId).label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="110" align="center" />
        <el-table-column label="操作" width="130" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewStoreDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="editStore(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-bar">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" />
    </div>
    <div class="form-footer-fixed">
      <el-button size="medium" @click="goBack"><i class="el-icon-back"></i> 返回流程详情</el-button>
      <span class="footer-hint">渠道：{{ workflowName }}</span>
    </div>
  </div>
</template>
<script>
import {mockStoresByWorkflow, mockMerchantsByWorkflow, mockWorkflows} from "./mockWorkflowData";
import { storeAuditRecords } from "./mockData";
export default {
  name: "storeList",
  data() {
    return {
      flowId: '', merchantId: '', workflowName: '', merchantName: '', merchantCode: '',
      allStores: [], tableData: [], tableLoading: false, tableHeight: '380px',
      currentPage: 1, pageSize: 20, total: 0, totalStoreNum: 0,
      merchants: [],
      searchForm: { merchantId: '', storeName: '', storeCode: '', address: '' },
    };
  },
  created() {
    this.flowId = this.$route.params.flowId || '';
    this.loadData();
    this.setTableHeight();
  },
  methods: {
    setTableHeight() {
      if (typeof window !== 'undefined') {
        this.tableHeight = Math.round((window.innerHeight || document.documentElement.clientHeight) * 0.55) + 'px';
      }
    },
    loadData() {
      this.merchants = mockMerchantsByWorkflow[this.flowId] || [];
      const wf = mockWorkflows.find(w => w.id === this.flowId);
      if (wf) {
        this.workflow = { ...wf };
        this.workflowName = wf.channelName;
      } else {
        this.workflowName = '流程 ' + this.flowId;
      }
      this.allStores = mockStoresByWorkflow[this.flowId] || [];
      this.totalStoreNum = this.allStores.length;
      this.filterData();
    },
    filterData() {
      const merchantMap = {};
      this.merchants.forEach(m => { merchantMap[m.merchantId] = m.merchantName; });
      let list = [...this.allStores].map(s => ({ ...s, merchantName: merchantMap[s.merchantId] || s.merchantId }));
      const mid = this.searchForm.merchantId;
      const sn = (this.searchForm.storeName || '').trim();
      const sc = (this.searchForm.storeCode || '').trim();
      const sa = (this.searchForm.address || '').trim();
      if (mid) list = list.filter(s => s.merchantId === mid);
      if (sn) list = list.filter(s => s.storeName.includes(sn));
      if (sc) list = list.filter(s => s.storeCode.includes(sc));
      if (sa) list = list.filter(s => s.address.includes(sa));
      this.total = list.length;
      const start = (this.currentPage - 1) * this.pageSize;
      this.tableData = list.slice(start, start + this.pageSize);
    },
    getStoreAuditStatus(storeId) {
      const records = storeAuditRecords[storeId];
      if (!records || records.length === 0) return { label: '未提交', color: 'info' };
      const latest = records[0];
      if (latest.type.includes('通过')) return { label: '已通过', color: 'success' };
      if (latest.type.includes('驳回') || latest.type.includes('不通过')) return { label: '已驳回', color: 'danger' };
      return { label: '审核中', color: 'warning' };
    },
    onSearch() { this.currentPage = 1; this.filterData(); },
    onReset() { this.searchForm = { merchantId: '', storeName: '', storeCode: '', address: '' }; this.onSearch(); },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.filterData(); },
    handleCurrentChange(val) { this.currentPage = val; this.filterData(); },
    goBack() { this.$router.push('/sys/workflow/view/' + this.flowId); },
    viewStoreDetail(row) {
      this.$router.push('/sys/workflow/storeDetail/' + this.flowId + '/' + row.storeId);
    },
    addStore() { this.$message.success('新增门店功能（待对接API）'); },
    editStore(row) { this.$message.success('编辑门店：' + row.storeName + '（待对接API）'); },
    importStoreExcel() { this.$message.success('导入门店Excel功能（待对接API）'); },
    exportStore() { this.$message.success('导出功能（待对接API）'); },
  }
};
</script>
<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; text-align: left; }
.flex-header { flex-shrink: 0; background: #fff; padding-bottom: 10px; }
.header-top { display: flex; align-items: center; justify-content: space-between; }
.header-stats { display: flex; align-items: center; gap: 20px; flex-shrink: 0; }
.stats-item { display: flex; align-items: center; }
.flex-item:nth-child(2) { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.table-wrapper { flex: 1; min-height: 0; overflow: hidden; }
.stats-num { font-size: 20px; font-weight: 700; color: #409EFF; line-height: 1.2; }
.stats-label { font-size: 12px; color: #909399; margin-left: 4px; }
.search-form { margin-bottom: 8px; }
.action-bar { margin-bottom: 10px; }
.pagination-bar { text-align: right; padding: 8px 0; flex-shrink: 0; }
.form-footer-fixed { text-align: center; padding: 16px 0; border-top: 1px solid #ebeef5; background: #fff; flex-shrink: 0; position: relative; z-index: 10; }
.form-footer-fixed .el-button { min-width: 140px; }
.footer-hint { margin-left: 20px; font-size: 13px; color: #909399; }
</style>
